// src/lib/supabaseAuth.js
//
// The dedicated Supabase Auth client for email sign-in (mission 007). Its
// session (storageKey 'lunexx-email-auth') only proves the email to the
// email-session Edge function; the app's identity stays the Lunexx JWT. The
// data client (lib/supabase.js) keeps no session, so the auth.uid() RLS
// policies stay inert for data reads. Created on first use: with the flag off
// it never exists.

import { createClient } from '@supabase/supabase-js';

let client = null;
export function getSupabaseAuth() {
  if (!client) {
    client = createClient(
      process.env.REACT_APP_SUPABASE_URL || 'https://demo.supabase.co',
      process.env.REACT_APP_SUPABASE_ANON_KEY || 'demo-key',
      { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false, storageKey: 'lunexx-email-auth' } },
    );
  }
  return client;
}
